<template>
    <div class="container">
        <div class="choPacBox">
            <div class="choosePacket">
                <div class="chopacTop">
                    <p class="myPacket">我的红包</p>
                    <p class="offmyPac" @click="offPack">取消</p>
                </div>
                <!--可用红包 不可用红包 tab切换-->
                <mt-navbar v-model="selected">
                    <mt-tab-item id="1">可用红包</mt-tab-item>
                    <mt-tab-item id="2">不可用红包</mt-tab-item>
                </mt-navbar>

                <!-- tab-container -->
                <mt-tab-container v-model="selected">
                    <!--可用红包-->
                    <mt-tab-container-item id="1">
                        <div class="packetPad">
                            <packet :my-packet="packetAble" @childChoosed="choosedPacket"></packet>
                        </div>
                        <div class="noDataChoose" v-if="nopacketAble">空空如也～</div>
                    </mt-tab-container-item>
                    <!--不可用红包-->
                    <mt-tab-container-item id="2">
                        <div class="packetPad">
                            <packet :my-packet="packetDis"></packet>
                        </div>
                        <div class="noDataChoose" v-if="nopacketDis">空空如也～</div>
                    </mt-tab-container-item>
                </mt-tab-container>
            </div>
        </div>
    </div>
</template>

<script>
    import packet from "./packet";
    import axios from "axios";
    import qs from "qs";
    import moment from "moment/moment.js";
    export default {
        name: "choosePacket",
        mounted() {
            this.getMypacket();
            // this.ifhasData();
        },
        data() {
            return {
                selected: '1',
                packetAble: [],
                packetDis: [],
                nopacketAble: false,
                nopacketDis: false
            };
        },
        components: {
            packet
        },
        methods: {
            //红包详情
            getMypacket:function() {
                axios
                    .post(
                        "/wap/RedBagShow/redBagList",
                        qs.stringify({
                            page: 1,
                        })
                    )
                    .then(data => {
                        //console.log(data);
                        var data = data.data.data;
                        if(data.length === 0){

                        }
                        for (var i = 0; i < data.length; i++) {
                            var objable={};
                            var objdis={}
                            objable.price = data[i].price;
                            objable.begin_time = moment(data[i].begin_time).format('YYYY.MM.DD');
                            objable.end_time = moment(data[i].end_time).format('YYYY.MM.DD');
                            objable.info = data[i].info;
                            objable.rb_name = data[i].rb_name;
                            objable.small_price = data[i].small_price;
                            objable.status = data[i].status;
                            objable.stabtn = false;
                            objable.id = data[i].id;
                            //判断是否为本专业的红包
                            var sbujectId = localStorage.getItem('sbujectId');
                            //本专业并且未使用 未过期  符合满减
                            var bookPrice = localStorage.getItem('bookPrice');//书单价
                            var bookNum = this.bookNum;//书数量
                            var packMony = bookPrice * bookNum - data[i].small_price;
                            if(sbujectId == data[i].subject_id && data[i].status == 1 && packMony >= 0) {
                                this.packetAble.push(objable);
                            }else{
                                this.packetDis.push(objable);
                            }
                        }
                    })
                    ["catch"](error => {
                    console.log(error);
                });
            },
            //点击取消关闭
            offPack:function () {
                this.$emit('childoff','false');
            },
            //点击红包  选中红包
            choosedPacket:function (price,id) {
                this.$emit('childoff','false');
                this.$emit('choosed',price,id);
            },
            // ifhasData:function () {
            //     //判断有无数据，没有数据进行提示
            //     if(this.packetAble.length == 0){
            //         this.nopacketAble = true;
            //     }else {
            //         this.nopacketAble = false;
            //     }
            //     if(this.packetDis.length == 0){
            //         alert(1);
            //         this.nopacketDis = true;
            //     }else{
            //         alert(2);
            //         this.nopacketDis = false;
            //     }
            // }
        },
        props: ['bookNum']
    };
</script>

<style scoped lang="scss">
    .container{
        width: 100%;
        height: 100%;
        position: fixed;
        bottom: 0;
        left: 0;
        background: rgba(0,0,0,0.5);
        z-index: 100;
        .choPacBox{
            position: fixed;
            overflow-y: scroll;
            overflow-x: hidden;
            bottom: 0;
            width: 100%;
            height: 70%;
            background: #fff;
            border-radius: 10px 10px 0 0;
            .mint-navbar{
                padding: 0 10%;
            }
            //tab切换
            .is-selected{
                width: 60px;
                color: #333;
                border-bottom: 6px solid #FF8005;
            }
            /deep/ .mint-tab-item-label{
                font-size: 32px;
            }
            .packetPad{
                padding: 30px;
            }
        }
        .chopacTop{
            position: relative;
            width: 100%;
            height: 100px;
            line-height: 100px;
            text-align: center;
            font-size: 34px;
            border-bottom: 1PX solid #DCDCDC;
            margin-bottom: 14px;
            .offmyPac{
                position: absolute;
                top: 0;
                right: 30px;
                font-size: 24px;
            }
        }
        .noDataChoose{
            height: 300px;
            line-height: 300px;
            text-align: center;
            font-size: 30px;
        }
    }
</style>
